import React, { useRef, useState } from 'react';
import { type IToolAvailableInput, type ToolButtonComponent } from '../Tool';
import { ApplicationView } from '@aha-app/mvc';
import ToolButton from '../../toolbars/ToolButton';
import { type Instance as TippyInstance } from 'tippy.js/index';
import ToolWireframe from './ToolWireframe';
import { isWireframe } from '../../objects/guards';
import { WIREFRAME_SELECTION_ERROR_MESSAGE } from '../../utils/tools';
import wireframeInputText from '../../assets/icons/wireframeInputText.svg';
import wireframeInputPlaceholder from '../../assets/icons/wireframeInputPlaceholder.svg';
import { svgToIcon } from '../../utils/svg';

const TextPlaceholderToggleButton: ToolButtonComponent = ApplicationView(
  ({ selection, tool }) => {
    if (!isWireframe(selection)) {
      console.error(WIREFRAME_SELECTION_ERROR_MESSAGE);
      return null;
    }

    const tippyRef = useRef<TippyInstance>();
    const initialState = selection.wireframe.placeholder?.state;
    const [state, setState] = useState(initialState);
    const icon =
      state === 'text' ? wireframeInputText : wireframeInputPlaceholder;

    return (
      <ToolButton
        tool={tool}
        tippyRef={tippyRef}
        onClick={() => {
          selection.wireframe.togglePlaceholderState();
          setState(selection.wireframe.placeholder?.state);
        }}
      >
        {svgToIcon(icon)}
      </ToolButton>
    );
  }
);

class ToolWireframePlaceholderText extends ToolWireframe {
  static toolName = 'Placeholder';

  static available({ selection }: IToolAvailableInput) {
    return selection?.type === 'wireframe';
  }

  static buttonComponent() {
    return TextPlaceholderToggleButton;
  }
}

export default ToolWireframePlaceholderText;
